import '../styles/whatIDo.scss'
import Fade from 'react-reveal/Fade';
import { WhatIDoLabels } from '../constants/constants';
import { useSelector } from 'react-redux';

const WhatIDo = () => {

        //Setting up a hook on current language
        const storeCurrentLanguage = state => state.language;
        const currentLanguage = useSelector(storeCurrentLanguage);

    return (
        <div className = 'what-i-do'>
           <Fade left><div>{WhatIDoLabels.labels['1'][currentLanguage]}</div></Fade>
           <Fade right><div>{WhatIDoLabels.labels['2'][currentLanguage]}</div></Fade>
           <Fade left><div>{WhatIDoLabels.labels['3'][currentLanguage]}</div></Fade>
        </div>
        
    )
    
}
export default WhatIDo